import { SelectOption } from "@nms-angular-toolkit/nms-select";
import { NmsWizardStepModel } from "@nms-angular-toolkit/nms-wizard";

/**
 * Representa o modelo do step OscManagement do DwdmCircuitWizard.
 */
export class OscManagementStepModel extends NmsWizardStepModel {
    circuitId?: number;
    oscManagementPorts: OscPort[];
    useOscManagement: boolean;
    allOscs: OscManagementData[];
    constructor() {
        super();
        this.oscManagementPorts = [];
        this.useOscManagement = false;
        this.allOscs = [];
    }
}

/**
 * Dados de possível configuração OSC.
 */
export class OscManagementData {
    endResourceId: number;
    endName: string;
    portsSelection: SelectOption[];
    ports: OscManagementPortData[];
    txLinkId: number;
    linkTxName: string
    rxLinkId: number;
    linkRxName: string
    isUsed: boolean;
    identifier: string;
    toggleActive: boolean;
    port: string;
}

/**
 * Dados da porta de Gerência OSC.
 */
export class OscManagementPortData {
    circuitPortIdentifierData: CircuitPortIdentifierData
    portName: string
}

/**
 * Identificador da porta.
 */
export class CircuitPortIdentifierData {
    deviceResourceId: number;
    chassisIdentifier: string;
    slotIdentifier: string;
    portNo: number;
    portModelIdentifier: string;
}

/**
 * Dados utilizados para buscar as configurações de Gerência OSC
 * no banco.
 */
export class OscInputData {
    aEndResourceId: number;
    zEndResourceId: number;
    intermediatesResourceIds: number[];
    linksIds: number[];

    constructor(aEndResourceId: number, zEndResourceId: number, intermediatesResourceIds: number[],
        linksIds: number[]) {
        this.aEndResourceId = aEndResourceId;
        this.zEndResourceId = zEndResourceId;
        this.intermediatesResourceIds = intermediatesResourceIds;
        this.linksIds = linksIds;
    }
}

/**
 * Porta OSC configurada.
 */
export class OscPort {
    identifier: string;
    endId: number;
    endName: string;
    oscChassisIdentifier: string;
    oscSlotIdentifier: string;
    oscPortNo: number;
    oscPortModelIdentifier: string;
    oscPort: string;
    linkTxId: number;
    linkRxId: number;
    toggleActive: boolean
}

/**
 * Modelo de validação utilizado no passo OSC.
 */
export interface OscsValidatorData {
    oscs: Array<OscValidatorData>;
    aEndResourceId: number;
    zEndResourceId: number;
}

/**
 * Informações necessárias para validação de OSC.
 */
export interface OscValidatorData {
    deviceResourceId: number;
    linkRxId: number;
    linkTxId: number;
    chassis: string;
    slot: string;
    portNo: string;
    portModelIdentifier: string;
}
